export function createInAppNotificationClient(transport) {
    return {
        /**
         * POST /internal/v1/tenants/{tenantId}/in-app-notifications
         *
         * Requires scope: in-app-notifications:ingest
         */
        ingestInAppNotification(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/in-app-notifications`,
                body,
                options,
            });
        },
        /**
         * GET /v1/tenants/{tenantId}/users/{userId}/in-app-notifications
         *
         * Requires scope: in-app-notifications:read
         */
        listInAppNotifications(tenantId, userId, cursor, limit, state, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/users/${encodeURIComponent(userId)}/in-app-notifications`,
                query: { cursor: cursor, limit: limit, state: state },
                options,
            });
        },
        /**
         * POST /v1/tenants/{tenantId}/users/{userId}/in-app-notifications/{notificationId}/read
         *
         * Requires scope: in-app-notifications:write
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        postTenantsUsersInAppNotificationsRead(tenantId, userId, notificationId, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/users/${encodeURIComponent(userId)}/in-app-notifications/${encodeURIComponent(notificationId)}/read`,
                options,
            });
        },
        /**
         * POST /v1/tenants/{tenantId}/users/{userId}/in-app-notifications/{notificationId}/dismiss
         *
         * Requires scope: in-app-notifications:write
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        postTenantsUsersInAppNotificationsDismiss(tenantId, userId, notificationId, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/users/${encodeURIComponent(userId)}/in-app-notifications/${encodeURIComponent(notificationId)}/dismiss`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=in-app-notification.js.map